<app-breadcrumbs [title]="'MENU.ADMINISTRATION.CUSTOMER_ORDERS'" [first]="'MENU.ADMINISTRATION.CUSTOMER_ORDERS'"></app-breadcrumbs>
<div class="row">
    <dx-data-grid #table 
                    class="col-12 normal-white-space-header"
                    [dataSource]="dataSource" 
                    [rowAlternationEnabled]="true" [columnAutoWidth]="true"
                    [showBorders]="true" 
                    [showRowLines]="false" 
                    [showColumnLines]="false" 
                    [hoverStateEnabled]="true"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    columnResizingMode="nextColumn"
                    [masterDetail]="{ enabled: true, template: 'details' }">
        <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-pager [showInfo]="true"></dxo-pager>
        <dxo-state-storing [enabled]="true" [type]="'custom'" [customLoad]="loadGridState" [customSave]="saveGridState"></dxo-state-storing>

        <dxi-column [minWidth]="120" dataField="documentNumber" dataType="string" sortOrder="desc" [allowFiltering]="true" [allowSorting]="true" [caption]="'CUSTOMER_ORDERS.DOCUMENT_NUMBER' | translate"></dxi-column>
        <dxi-column [minWidth]="100" dataField="shippingFullName" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'CUSTOMER_ORDERS.BUYER' | translate"></dxi-column>
        <dxi-column [minWidth]="162" dataField="distributionCalendar.date" dataType="date" cellTemplate="distributionCalendarTemplate" [allowFiltering]="true" [allowSorting]="true" [caption]="'CUSTOMER_ORDERS.EXPECTED_SHIPMENT_TIME_PERIOD' | translate"></dxi-column>
        <dxi-column [minWidth]="190" dataField="distributionCalendar.deliveryZone.name" dataType="string" cellTemplate="locationTemplate" [allowFiltering]="false" [allowSorting]="true" [caption]="'SHARED.DELIVERY_ZONE' | translate"></dxi-column>
        <dxi-column [minWidth]="70" dataField="date" dataType="date"  [format]="{ type: 'dd.MM.yyyy' }" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.DATE' | translate"></dxi-column>
        <dxi-column [minWidth]="146" dataField="status" dataType="string" cellTemplate="statusTemplate" [allowFiltering]="true" [allowSorting]="true" [caption]="'SHARED.STATUS' | translate">
            <dxo-lookup [dataSource]="customerOrderStatuses" [valueExpr]="'value'" [displayExpr]="'label'"></dxo-lookup>
        </dxi-column>
        <dxi-column [minWidth]="146" dataField="buyer.userType" cellTemplate="userTypesTemplate" dataType="string" [allowFiltering]="true" [allowSorting]="true" [caption]="'ENUMS.BANNER_SCOPES.USER_TYPE' | translate">
            <dxo-lookup [dataSource]="userTypes" [valueExpr]="'value'" [displayExpr]="'label'"></dxo-lookup>
        </dxi-column>
        <dxi-column [minWidth]="70" dataField="invoiceValue" dataType="number" [format]="utilityService.twoDecimalFormat" [allowFiltering]="true" [allowSorting]="true" [caption]="'CUSTOMER_ORDERS.INVOICE_VALUE' | translate"></dxi-column>

        <dxi-column [minWidth]="70" dataField="totalValue" dataType="number" [format]="utilityService.twoDecimalFormat" [allowFiltering]="false" [allowSorting]="false" [caption]="'CUSTOMER_ORDERS.TOTAL_VALUE' | translate"></dxi-column>

        <dxi-column [minWidth]="50" cellTemplate="actionsTemplate" *ngIf="editable" [allowFiltering]="false" [allowSorting]="false" [fixed]="true" fixedPosition="right" [width]="40" [caption]="''" [cssClass]="'actions'"></dxi-column>

        <div *dxTemplate="let template of 'statusTemplate'">
            <span class="table-label {{template.data.status}}">{{ 'ENUMS.CUSTOMER_ORDERS_STATUS.' + template.data.status | translate }}</span>
        </div>
        
        <div *dxTemplate="let template of 'userTypesTemplate'">
            <span *ngIf="template.data.buyer?.userType == UserType[UserType.CLIENT_CUSTOMER]" class="table-label CLIENT_CUSTOMER">{{ 'ENUMS.USER_TYPES.' + template.data.buyer.userType | translate }}</span>
            <span *ngIf="!template.data.buyer" class="table-label CLIENT_PUBLIC">{{ 'ENUMS.USER_TYPES.CLIENT_PUBLIC'| translate }}</span>
        </div>
        <div *dxTemplate="let template of 'distributionCalendarTemplate'">
            {{ utilityService.formatDateToDDMMYYYY(template.data.expectedShipmentDate) }}
            <span class="text-sm">
                ({{ utilityService.formatDateTimeToTime(template.data.expectedShipmentTimeFrom) }} - 
                {{ utilityService.formatDateTimeToTime(template.data.expectedShipmentTimeTo) }})
            </span>
        </div>
        <div *dxTemplate="let template of 'locationTemplate'">
            {{ template.data.distributionCalendar?.deliveryZone?.name }} - {{ template.data.shippingMunicipality?.name }}
        </div>

        <div *dxTemplate="let template of 'actionsTemplate'">
            <span *ngIf="editable" class="table-icon ti-eye text-center d-block" [matTooltip]="'SHARED.VIEW' | translate" matTooltipPosition="above" matTooltipHideDelay="200" [routerLink]="['./', template.data.id]"></span>
        </div>
    
        <div *dxTemplate="let template of 'details'">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <span class="details-title">{{ 'CUSTOMER_ORDERS.DETAILS' | translate }}</span>
                        <hr class="wsh-hr hr-margin">
                        <div class="row">
                            <div class="col-6">
                                <div class=" mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text">{{ 'SHARED.FULL_NAME' | translate }}</span>
                                    <span class="pull-right text-bolder">{{ template.data.shippingFullName }}</span>
                                </div>
                                <div class="mt-3 mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text"> {{ 'SHARED.ADDRESS' | translate }} :</span>
                                    <span class="pull-right text-bolder">{{ template.data.shippingAddress }}</span>
                                </div>
                                <div class="mt-3 mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text"> {{ 'SHARED.MUNICIPALITY' | translate }} :</span>
                                    <span class="pull-right text-bolder">{{ template.data.shippingMunicipality?.name }}</span>
                                </div>
                                <div class="mt-3 mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text"> {{ 'SHARED.PHONE_NUMBER' | translate }} :</span>
                                    <span class="pull-right text-bolder">{{ template.data.shippingPhoneNumber }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class=" mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text">{{ 'CUSTOMER_ORDERS.EXPECTED_SHIPMENT_DATE' | translate }}</span>
                                    <span class="pull-right text-bolder">{{ utilityService.formatDate(template.data.expectedShipmentDate) }}</span>
                                </div>
                                <div class="mt-3 mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text"> {{ 'CUSTOMER_ORDERS.EXPECTED_SHIPMENT_TIME_PERIOD' | translate }} :</span>
                                    <span class="pull-right text-bolder">{{ utilityService.formatDateTimeToTime(template.data.expectedShipmentTimeFrom) }} - {{ utilityService.formatDateTimeToTime(template.data.expectedShipmentTimeTo) }}</span>
                                </div>
                                <div class="mt-3 mx-2 mx-md-3">
                                    <span class="dx-field-item-label-text"> {{ 'SHARED.NOTE' | translate }} :</span>
                                    <span class="pull-right text-bolder">{{ template.data.note }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dx-data-grid>
</div>